'use strict';

app.directive('rmScrollTo', function ($window, $document, $timeout, $viewport) {
  return {
    link: function (scope, element, attrs) {
      if (!angular.element($document[0].body).hasClass('app')) { return; }
      var targetId = attrs.rmScrollTo;
      element.on('click', function () {
        $timeout(function () {
          var target = $document[0].getElementById(targetId);
          if (!target) { return; }
          var padding = $viewport.isDesktop ? 90 : 10;
          var targetTop = target.getBoundingClientRect().top;
          if (targetTop < padding) {
            $window.scrollTo(0, targetTop + $window.pageYOffset - padding);
          }
        }, 100);
      });
    }
  };
});
